<p>auth-footer works!</p>
